import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeObsService {
  constructor() {}

  private fetchWorkspaceState = new BehaviorSubject<any>(false);
  fetchWorkspaceState$ = this.fetchWorkspaceState.asObservable();

  private fetchDiscoveryState = new BehaviorSubject<any>(false);
  fetchDiscoveryState$ = this.fetchDiscoveryState.asObservable();

  private fetchRequestsState = new BehaviorSubject<any>(false);
  fetchRequestsState$ = this.fetchRequestsState.asObservable();

  private fetchVaultSideNavState = new BehaviorSubject<any>(false);
  fetchVaultSideNavState$ = this.fetchVaultSideNavState.asObservable();

  private fetchMXSideNavState = new BehaviorSubject<any>(false);
  fetchMXSideNavState$ = this.fetchMXSideNavState.asObservable();

  private fetchAllAttributesSideDrawerState = new BehaviorSubject<any>(false);
  fetchAllAttributesSideDrawerState$ = this.fetchAllAttributesSideDrawerState.asObservable();

  private homeReportRefresh = new BehaviorSubject<any>({ isDirty: false, id: null });
  homeReportRefresh$ = this.homeReportRefresh.asObservable();

  // Network Setup Side Nav State
  private fetchNetworkSetupSideNavState = new BehaviorSubject<any>(false);
  fetchNetworkSetupSideNavState$ = this.fetchNetworkSetupSideNavState.asObservable();

  // About MFO Side Nav State
  private fetchAboutMFOSideNavState = new BehaviorSubject<any>(false);
  fetchAboutMFOSideNavState$ = this.fetchAboutMFOSideNavState.asObservable();

  handleFetchWorkspaceState(val: any) {
    this.fetchWorkspaceState.next(val);
  }

  handleFetchDiscoveryState(val: any) {
    this.fetchDiscoveryState.next(val);
  }

  handleFetchRequestsState(val: any) {
    this.fetchRequestsState.next(val);
  }

  handleFetchVaultSideNavState(val: any) {
    this.fetchVaultSideNavState.next(val);
  }

  handleFetchMXSideNavState(val: any) {
    this.fetchMXSideNavState.next(val);
  }

  handleFetchAllAttributesSideDrawerState(val: any) {
    this.fetchAllAttributesSideDrawerState.next(val);
  }

  handleHomeReportRefresh(val: any, id: any) {
    this.homeReportRefresh.next({ isDirty: val, id: id });
  }

  handleFetchNetworkSetupSideNavState(val: any) {
    this.fetchNetworkSetupSideNavState.next(val);
  }

  handleFetchAboutMFOSideNavState(val: any) {
    this.fetchAboutMFOSideNavState.next(val);
  }

  // About MFO Status Update
  private aboutMFOStatusUpdate = new BehaviorSubject<any>(null);
  aboutMFOStatusUpdate$ = this.aboutMFOStatusUpdate.asObservable();

  handleAboutMFOStatusUpdate(status: string) {
    this.aboutMFOStatusUpdate.next({ status });
  }

  // Open AI Chat
  private openAiChatState = new BehaviorSubject<boolean>(false);
  openAiChatState$ = this.openAiChatState.asObservable();

  handleOpenAiChat(val: boolean) {
    this.openAiChatState.next(val);
  }

  resetAllStates() {
    this.fetchWorkspaceState.next({ open: false });
    this.fetchDiscoveryState.next({ open: false });
    this.fetchRequestsState.next({ open: false });
    this.fetchVaultSideNavState.next({ open: false });
    this.fetchMXSideNavState.next({ open: false });
    this.fetchAllAttributesSideDrawerState.next({ open: false });
    this.fetchNetworkSetupSideNavState.next({ open: false });
    this.fetchAboutMFOSideNavState.next({ open: false });
    this.homeReportRefresh.next({ isDirty: false, id: null });
    this.openAiChatState.next(false);
  }

}
